import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { TheWestLiveBillboardProps } from './TheWestLiveBillboard'
import { LazyTheWestLiveBillboard } from './TheWestLiveBillboard.lazy'

export const TheWestLiveBillboardRegistration = createRegisterableComponent(
    'the-west-live-billboard',
    (props: TheWestLiveBillboardProps) => {
        return <LazyTheWestLiveBillboard {...props} />
    },
)
